import React from "react";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";

export default function UserRegisterButton() {
  const navigate = useNavigate();
  return (
    <Button
      variant="contained"
      buttonstyle={{ borderRadius: 25 }}
      startIcon={
        <div>
          <AddOutlinedIcon sx={{ width: "16px", height: "16px" }} />
          <PersonOutlineIcon sx={{ width: "16px", height: "16px" }} />
        </div>
      }
      style={{ borderRadius: 25 }}
      sx={{
        color: "white",
        fontSize: "12px",
        fontWeight: "bold",
        backgroundColor: "#28345e",
        py: "10px",
        px: "20px",
        width: "100%",
        "&:hover": {
          background: "#8bb6c6",
        },
      }}
      onClick={() => navigate("/adminManagement/userRegister")}
    >
      新規追加
    </Button>
  );
}
